import { render } from "./AdminMailgunConfig.vue?vue&type=template&id=6c8948ff"
import script from "./AdminMailgunConfig.vue?vue&type=script&lang=js"
export * from "./AdminMailgunConfig.vue?vue&type=script&lang=js"

import "./AdminMailgunConfig.vue?vue&type=style&index=0&id=6c8948ff&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__